module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p6-afb40fc4f0b801b99a41532499cbc068.png";